import React from "react";
import { useIntl } from "react-intl";
import Layout from "../components/features/Default/layout/layout";

const Payments = () => {
  const intl = useIntl();
  return (
    <Layout pageProps={{ title: intl.formatMessage({ id: "footer.policy.payments" }) }}>
      <div className="bg-white rounded-[16px] px-4 py-4 md:h-screen md:w-full sm:w-screen sm:h-max">
        <div className="text-center uppercase font-bold text-[22px] py-4">
          <span>Hình thức thanh toán</span>
        </div>
        <span>
          <b>JLPTUP.com</b> cung cấp sản phẩm kỹ thuật số như một đơn vị tiền tệ trên website - Kim cương - để đáp ứng
          nhu cầu trải nghiệm những tính năng nâng cao có tính phí của người dùng. Bạn có thể thu thập kim cương miễn
          phí bằng cách làm nhiệm vụ trên website JlptUp.com hoặc mua các gói nạp kim cương bằng cách chuyển khoản vào
          tài khoản bên dưới với nội dung gồm mã khách hàng và gói nạp.
        </span>
        <div className="py-2 px-4 font-bold">
          <i>
            Để được hướng dẫn thông tin chuyển khoản, vui lòng liên hệ với JlptUp.com qua hộp thư thoại ngay trên
            website hoặc qua fanpage:{" "}
            <a
              href="https://www.facebook.com/fb.jlptup.com"
              target="_blank"
              rel="noreferrer"
              className="text-blueLink hover:underline"
            >
              Jlpt Up
            </a>
          </i>
        </div>
        <div>
          <span>
            <i>Lưu ý :</i> Nếu bạn chưa được tự chủ tài chính của bản thân vui lòng hỏi ý kiến phụ huynh trước khi tiến
            hành thanh toán bằng bất kỳ phương thức nào được nêu trên.{" "}
          </span>
        </div>
      </div>
    </Layout>
  );
};

export default Payments;
